import Trigger from 'eflex/models/trigger';

export default class AudioTrigger extends Trigger {}
